<template>
  <a-row :gutter="24">
    <a-col :span="12">
      <a-form-model-item label="项目编号" prop="projectId">
        <a-input
          v-model="form.projectId"
          disabled
          placeholder="审核通过后系统自动生成"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="项目名称" prop="projectName">
        <a-input
          v-model="form.projectName"
          placeholder="例：上海市金山区浩源路XXX号X号楼X年租赁权"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="是否关联意向发布" prop="stateIntentProject">
            <a-radio-group v-model="form.stateIntentProject" disabled>
              <a-radio :value="1">是</a-radio>
              <a-radio :value="0">否</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="出租方式" prop="rentWay">
        <a-radio-group v-model="form.rentWay" disabled>
          <a-radio :value="2">进场公开招租</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item
        label="是否国资"
        prop="stateOwned"
        extra="和出租方是否国资一致"
      >
        <a-radio-group v-model="form.stateOwned" disabled>
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>

    <a-col :span="12">
      <a-form-model-item label="是否在线报名" prop="onlineSignup">
        <a-radio-group v-model="form.onlineSignup" disabled>
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({}),
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>

<style>
</style>